export default "__VITE_ASSET__89d50857__"